import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { FC, useMemo } from 'react'

import { Logic, Operator } from 'core-components/types'

import { getJbpPbmListCrud } from './helpers/getJbpPbmListCrud'
import { IPbmMultiselectProps } from './models'

export const PbmMultiselect: FC<IPbmMultiselectProps> = ({
  onChange,
  value,
  className,
  partnersType,
}) => {
  const source = useMemo(() => {
    const crud = getJbpPbmListCrud()

    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RTM',
          operator: Operator.EQUAL,
          value: partnersType,
        },
      ],
    })

    return crud
  }, [partnersType])

  const handleChange = (value: string[]) => {
    onChange(value)
  }

  return (
    <MultiSelect
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      value={value}
      source={source}
      label="PBM"
      caption={'Email'}
      onChange={handleChange}
    />
  )
}
